<template>
  <!-- MBR053 Transaction Details — Heritage Hearth (the navbar already hides itself on this route) -->
  <div class="page-header align-items-start min-vh-100 mbr-txn">
    <span class="mask bg-white"></span>
    <div class="container p-0">
      <header class="mbr-txn__bar">
        <button type="button" class="mbr-txn__back" :aria-label="$t('common.back')" @click="myTransactions()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 class="mbr-txn__title">{{ $t('transaction.title') }}</h1>
        <span class="mbr-txn__spacer" aria-hidden="true"></span>
      </header>

      <main v-if="isLoadDone" class="mbr-txn__body">
        <section class="mbr-txn__hero">
          <span class="mbr-txn__eyebrow">{{ type.TYPE }}</span>
          <div class="mbr-txn__amount" :class="type.SIGN == '+' ? 'mbr-txn__amount--in' : 'mbr-txn__amount--out'">
            {{ type.SIGN == "-" ? "\u2212" : type.SIGN }}{{ transactionDetail.payment_amount }}
          </div>
          <span
            class="mbr-txn__status"
            :class="transactionDetail.status == 1 ? 'mbr-txn__status--ok' : 'mbr-txn__status--fail'"
          >
            {{ transactionDetail.status == 1 ? $t('transaction.successful') : $t('transaction.failed') }}
          </span>
        </section>

        <dl class="mbr-txn__card">
          <div class="mbr-txn__line">
            <dt>{{ $t('transaction.type') }}</dt>
            <dd>{{ type.TYPE }}</dd>
          </div>
          <div class="mbr-txn__line" v-if="transactionDetail.transaction_id">
            <dt>{{ $t('transaction.id') }}</dt>
            <dd>{{ transactionDetail.transaction_id }}</dd>
          </div>
          <div class="mbr-txn__line">
            <dt>{{ $t('transaction.status') }}</dt>
            <dd :class="transactionDetail.status == 1 ? 'mbr-txn__ok' : 'mbr-txn__fail'">
              {{ transactionDetail.status == 1 ? $t('transaction.successful') : $t('transaction.failed') }}
            </dd>
          </div>
          <div class="mbr-txn__line">
            <dt>{{ $t('transaction.amount') }}</dt>
            <dd>{{ type.SIGN }} {{ transactionDetail.payment_amount }}</dd>
          </div>
          <div class="mbr-txn__line">
            <dt>{{ $t('transaction.date_time') }}</dt>
            <dd>{{ transactionDetail.createdAt }}</dd>
          </div>
          <div class="mbr-txn__line">
            <dt>{{ $t('transaction.location') }}</dt>
            <dd>{{ (transactionDetail.transaction_merchant || {}).brand_name }}</dd>
          </div>
        </dl>
      </main>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MemberService from "../services/member.service";
import "bootstrap/dist/js/bootstrap.bundle";
import { errorMessage } from "@/utils/errorMessage";

export default {
  name: "sign-in",
  components: {
    MaterialSnackbar,
  },
  data() {
    return {
      transactionDetail: {},
      transactionType: [],
      isLoadDone: false,
      loaderActive: false,
    };
  },
  computed: {
    // { SIGN, TYPE }; empty until the detail loads (or when it fails)
    type() {
      return this.transactionDetail.transaction_type || {};
    },
  },
  mounted() {
    this.getTransactionDetail();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    ...mapActions(["setHeaderColor", "setLabelColor", "setButtonColor"]),
    ...mapState(["isPinned"]),
    getTransactionDetail() {
      this.isLoadDone = false;
      this.showLoader();
      var transactionID = this.$route.params.transaction_id;
      MemberService.transactionDetail(transactionID).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.transactionDetail = response.data.data;
            this.transactionType = response.data.data.transaction_type;
          } else {
            this.snackbar = "danger";
            this.message = errorMessage(response.data.result.message);
          }
          this.isLoadDone = true;
          this.hideLoader();
        },
        (error) => {
          this.isLoadDone = true;
          console.log(error);
        }
      );
    },
    myTransactions() {
      this.$router.go(-1);
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>
<style scoped>
/* MBR053 Transaction Details */
.mbr-txn.page-header {
  overflow: visible;
  overflow-x: clip;
  padding-bottom: 40px;
  font-family: var(--mbr-font-body);
  color: var(--mbr-color-ink-headline);
}

/* custom.css still carries the legacy `* { font-family: Poppins }` */
.mbr-txn :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-txn .mask {
  background: var(--mbr-color-canvas) !important;
  opacity: 1;
}

.mbr-txn .container {
  max-width: 440px;
  margin: 0 auto;
}

.mbr-txn__bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 20px 16px;
  background: var(--mbr-nav-bg);
  border-bottom: 1px solid rgba(var(--mbr-color-outline-rgb), 0.3);
  backdrop-filter: blur(var(--mbr-nav-blur));
  -webkit-backdrop-filter: blur(var(--mbr-nav-blur));
}

.mbr-txn__back,
.mbr-txn__spacer {
  flex: none;
  width: 40px;
  height: 40px;
}

.mbr-txn__back {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.4);
  border-radius: var(--mbr-radius-full);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
  color: var(--mbr-color-ink-headline);
  transition: transform 0.15s ease;
}

.mbr-txn__back:active {
  transform: scale(0.95);
}

.mbr-txn__back:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}

.mbr-txn__back svg {
  width: 20px;
  height: 20px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-txn__title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: var(--mbr-color-ink-headline);
  text-align: center;
}

.mbr-txn__body {
  padding: 20px 20px 0;
}

.mbr-txn__hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 0 20px;
  text-align: center;
}

.mbr-txn__eyebrow {
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mbr-color-ink-secondary);
}

.mbr-txn__amount {
  font-family: var(--mbr-font-headline);
  font-size: 32px;
  font-weight: 800;
  line-height: 40px;
  letter-spacing: -0.025em;
  overflow-wrap: anywhere;
}

.mbr-txn__amount--in {
  color: var(--mbr-color-positive);
}

.mbr-txn__amount--out {
  color: var(--mbr-color-primary);
}

.mbr-txn__status {
  padding: 3px 10px;
  border-radius: var(--mbr-radius-full);
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
}

.mbr-txn__status--ok {
  background: rgba(var(--mbr-color-positive-rgb), 0.1);
  color: var(--mbr-color-positive);
}

.mbr-txn__status--fail {
  background: var(--mbr-color-error-container);
  color: var(--mbr-color-error);
}

.mbr-txn__card {
  margin: 0;
  padding: 4px 18px;
  background: var(--mbr-color-card);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-xl);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
}

.mbr-txn__line {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
}

.mbr-txn__line + .mbr-txn__line {
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.4);
}

.mbr-txn__line dt {
  flex: none;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-txn__line dd {
  min-width: 0;
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  color: var(--mbr-color-ink-strong);
  text-align: right;
  overflow-wrap: anywhere;
}

.mbr-txn__line dd.mbr-txn__ok {
  color: var(--mbr-color-positive);
}

.mbr-txn__line dd.mbr-txn__fail {
  color: var(--mbr-color-error);
}
</style>
